import React, { useEffect, useRef, useState } from "react";
import { Modal, Button } from "react-bootstrap";
import { Autocomplete } from "@react-google-maps/api";
import { Link } from "react-router-dom";
import LocationIcon from "../../../icons/LocationIcon";
import CrossIcon from "../../../icons/CrossIcon";
import "./style.scss";

interface AddLocationModalProps {
  show: boolean;
  handleClose: () => void;
  handleSave: () => void;
  locations: any[];
  setLocations: any;
  address: string;
  setAddress: (value: string) => void;
  lat: number | null;
  setLat: (value: any) => void;
  lng: number | null;
  setLng: (value: any) => void;
  city: string;
  setCity: (value: string) => void;
  zipCode: string;
  setZipCode: (value: string) => void;
  required?: boolean;
}

const AddLocationModal: React.FC<AddLocationModalProps> = ({
  show, handleClose, handleSave, locations, setLocations, address, setAddress,
  lat, setLat, lng, setLng, city, setCity, zipCode, setZipCode, required
}) => {
  const [autocomplete, setAutocomplete] = useState<any>(null);
  const [myBusinessAccount, setMyBusinessAccount] = useState<boolean>(false);
  const autocompleteRef = useRef<any>(null);

  const handleLoad = (autoCompleteInstance: any) => {
    autocompleteRef.current = autoCompleteInstance;
    setAutocomplete(autoCompleteInstance);
  };

  useEffect(() => {
    //
  }, [setLocations, zipCode, city, show]);

  const handlePlaceChanged = async () => {
    if (!autocomplete) return;

    const place = autocomplete.getPlace();
    const location = place.geometry?.location;
    let zipCodeValue = "";
    let cityValue = "";

    if (place.address_components) {
      place.address_components.forEach((component: any) => {
        const types = component.types;
        if (types.includes("postal_code")) {
          zipCodeValue = component.long_name;
          setZipCode(zipCodeValue);
        }
        if (types.includes("locality")) {
          cityValue = component.long_name;
          setCity(cityValue);
        }
      });
    }

    if (place.place_id) {
      setMyBusinessAccount(true);
    }

    if (location) {
      const newLocation = {
        lat: location.lat(),
        lng: location.lng(),
        address: place.formatted_address,
        hasBusinessAccount: myBusinessAccount,
        zipCode: zipCodeValue,
        city: cityValue,
      };

      const isDuplicate = locations?.some((loc) => loc.address === place.formatted_address);

      if (!isDuplicate) {
        setLocations([...locations, newLocation]);
      }
    }
  };

  const deleteLocation = (indexToRemove: number) => {
    setLocations(locations?.filter((_, index) => index !== indexToRemove));
  };

  const addMoreLocations = () => {
    setAddress("");
    setZipCode("");
    setCity("");
  };

  return (
    <Modal show={show} onHide={required ? undefined : handleClose} centered backdrop={required ? "static" : true}>
      <Modal.Header closeButton={!required}>
        <Modal.Title>Add New Location</Modal.Title>
      </Modal.Header>

      <Modal.Body className="modal-scroll-body">
        <div className="form-group">
          {locations?.map((item, index) => (
            <div key={index} className="addressSelect">
              <label className="mb-3 w-100">
                Address {index + 1}{" "}
                <button type="button" onClick={() => deleteLocation(index)}>
                  <CrossIcon />
                </button>
              </label>
              {item.address}
            </div>
          ))}
        </div>

        <div className="form-group">
          <label className="mb-3 w-100">Address</label>
          <div className="group-img iconLeft email position-relative location-search">
            <label>
              <LocationIcon />
            </label>
            <Autocomplete
              onLoad={handleLoad}
              onPlaceChanged={handlePlaceChanged}
            >
              <input
                type="text"
                name="search"
                className="commonInput form-control"
                placeholder="Search for a place"
                value={address}
                onChange={(e) => setAddress(e.target.value)}
              />
            </Autocomplete>
          </div>
        </div>

        <div className="form-group d-flex gap-3">
          <input
            type="text"
            name="zipCode"
            className="commonInput form-control"
            placeholder="Zip code"
            value={zipCode}
            onChange={(e) => { setZipCode(e.target.value) }}
          />
          <input
            type="text"
            name="city"
            className="commonInput form-control"
            placeholder="City"
            value={city}
            onChange={(e) => setCity(e.target.value)}
          />
        </div>

        <div className="form-group d-flex justify-content-end mt-2">
          <p className="mb-0">
            You have more than 1 location?
            <button onClick={addMoreLocations} className="addEvent" type="button">
              + Add more location
            </button>
          </p>
        </div>
      </Modal.Body>

      <Modal.Footer>
        {!required && (
          <Button className="custom-close-btn" onClick={handleClose}>
            Close
          </Button>
        )}

        <Button className="custom-save-btn" onClick={handleSave} disabled={locations.length === 0}>
          Save
        </Button>
      </Modal.Footer>

    </Modal>
  );
};

export default AddLocationModal;
